<template>
  <div
    v-bind:class="{ 'modal': modal,'fade': modal }"
    tabindex="-1"
    role="dialog"
    aria-labelledby="formLabel"
    aria-hidden="true"
    :id="id"
  >
    <div class="modal-dialog" v-bind:class="{'modal-lg': tamanho == 'lg'}" role="document">
      <div class="modal-content">
        <div class="modal-header" v-if="!hideHeader">
          <h5 class="modal-title" v-if="!tituloCenter">{{titulo}}</h5>
          <h5 class="modal-title text-center" style="width:100%" v-if="tituloCenter">{{titulo}}</h5>
          <button
            type="button"
            class="close"
            v-bind:class="{ 'd-none': !modal || hideCloseButton}"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <slot></slot>
        </div>
        <div v-if="!hideFooter" v-bind:class="{'modal-footer': !noClassFooter}">
          <slot name="rodape"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Dialog",
  components: {},
  props: {
    id: String,
    titulo: String,
    modal: { type: Boolean, default: true },
    tamanho: { type: String, default: "" },
    hideCloseButton: { type: Boolean, default: false },
    hideHeader: { type: Boolean, default: false },
    hideFooter: { type: Boolean, default: false },
    noClassFooter: { type: Boolean, default: false },
    tituloCenter: { type: Boolean, default: false }
  },
  methods: {
    fechar() {
      window.$("#" + this.id).modal("hide");
    },
    abrir() {
      window.$("#" + this.id).modal("show");
    },
  },
};
</script>

<style>
:focus {
  outline: 0;
}

.modal { overflow: auto !important; }

.modal-dialog{
  margin-top:20px!important
}

</style>